// Copyright (c) 2016 Deere & Company

import actions from '../../../action-list';
import {routerActions} from 'react-router-redux';

export const copyClaim = claim =>

    dispatch => {

        dispatch({
            isCopied: true,
            type: actions.COPY_CLAIM_MCC_FOLLOWUP
        });

        dispatch(routerActions.replace(`/claims/mcc-followup/new/${claim.pin}`));

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/action-creators/copy-claim.js